export const ONBOARDING_SYNC_COPY = {
	ADD_TEAM_INFO: 'Add your team\'s contact info below to get started.',
	CLOSE_THIS_TAB: 'You can close this tab while you wait',
	CONNECTING_FIRST_TIME: 'Connecting to Salesforce for the first time.',
	INVITES_SENT: 'Invites sent! Send some more?',
	MAIN_DIALOG: 'Arovy makes it easy to see how everyone is working across your org. ' +
        'By inviting others, everyone gains the visibility and insights to make smart changes quickly. ' +
        'Plus, you can collaborate on projects and monitor progress on updates.',
	READY_SHORTLY: 'Arovy will be ready shortly. While you wait, invite your team!',
	SEND_INVITES: 'Send Invites',
	SYNCING_ORG: 'Success! Your organization is being synced in the background.'
};
